import { LabelSchema } from "@storytell/types";
import { RequestBuilder } from "../requestBuilder";
import {
  AssociateLabelResponseSchema,
  BulkAssociateLabelInputSchema,
  BulkDisassociateLabelInputSchema,
  CreateLabelInputSchema,
  LabelAssociationsSyncSchema,
  LabelIdParamsSchema,
  LabelsSyncSchema,
  ResourceLabelAssociationsParamsSchema,
  ResourceLabelAssociationsSchema,
  UpdateLabelInputSchema,
} from "./labelClient.types";

export const LabelsSyncRequestConfig = new RequestBuilder({
  path: () => "/labels-sync",
  responseSchema: LabelsSyncSchema,
}).withIncludeProjectId();

export const CreateLabelRequestConfig = new RequestBuilder({
  path: () => "/labels",
  responseSchema: LabelSchema,
  bodySchema: CreateLabelInputSchema,
})
  .withMethod("POST")
  .withIncludeProjectId();

export const UpdateLabelRequestConfig = new RequestBuilder({
  paramsSchema: LabelIdParamsSchema,
  path: ({ id }) => `/labels/${id}`,
  responseSchema: LabelSchema,
  bodySchema: UpdateLabelInputSchema,
})
  .withMethod("POST")
  .withIncludeProjectId();

export const AssociateLabelRequestConfig = new RequestBuilder({
  path: () => "/label-associations",
  responseSchema: AssociateLabelResponseSchema,
  bodySchema: BulkAssociateLabelInputSchema,
})
  .withMethod("POST")
  .withIncludeProjectId();

export const DisassociateLabelRequestConfig = new RequestBuilder({
  path: () => "/label-associations/disassociate",
  bodySchema: BulkDisassociateLabelInputSchema,
})
  .withMethod("POST")
  .withIncludeProjectId();

export const LabelAssociationsSyncRequestConfig = new RequestBuilder({
  path: () => "/label-associations",
  responseSchema: LabelAssociationsSyncSchema,
}).withIncludeProjectId();
// GET /labels/system/artifact - The project's built-in label for saved artifacts
export const SystemArtifactLabelRequestConfig = new RequestBuilder({
  path: () => "/labels/system/artifact",
  responseSchema: LabelSchema,
}).withIncludeProjectId();

// GET /label-associations?resourceType=&resourceId= - One resource's label associations
export const ResourceLabelAssociationsRequestConfig = new RequestBuilder({
  paramsSchema: ResourceLabelAssociationsParamsSchema,
  path: () => "/label-associations",
  responseSchema: ResourceLabelAssociationsSchema,
})
  .withQueryParams((params) =>
    params ? { resourceType: params.resourceType, resourceId: params.resourceId } : undefined
  )
  .withIncludeProjectId();
